import {NgModule} from '@angular/core';

import {MdcFormFieldModule} from '@shraddhar/mdc-test-web/form-field';
import {MdcRadio} from './radio';
import {MdcRadioGroup} from './radio-group';

@NgModule({
  imports: [MdcFormFieldModule],
  exports: [MdcRadioGroup, MdcRadio, MdcFormFieldModule],
  declarations: [MdcRadioGroup, MdcRadio]
})
export class MdcRadioModule { }
